
export interface ConflictKeywordGq {
  keywordId: number;
  keyword: string;
  translationEnglish?: string;
  translatedFromKeyword?: string;
  tagGroupId: number;
  tagGroupName: string;
  conflictTags: ConflictTagGq[];
}

export interface ConflictTagGq {
  tagId: number;
  tagName: string;
}

export const ConflictTagGqProps = `
  tagId,
  tagName
`;

export const ConflictKeywordGqProps = `
  keywordId,
  keyword,
  translationEnglish,
  translatedFromKeyword,
  tagGroupId,
  tagGroupName,
  conflictTags { ${ConflictTagGqProps} }
`;